import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Controller } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import InitTabs from '@utils/initTabs';
import FloorsGraphic from '@utils/FloorsGraphic';
import initModels from '@utils/initModels';
import initModelMedia from '@utils/initModelMedia';
import { initLocationTabs } from '@utils/initLocation';
import initAnimations from '@utils/initAnimations';

document.addEventListener('DOMContentLoaded', function ()
{
    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    initModels();
    initModelMedia();
    initLocationTabs();

    const swiperSpacesEl = document.querySelector(".swiper-spaces");
    const spacesGallery = document.querySelector('[data-js="spaces-gallery"]');
    const spacesPagination = document.querySelector('[data-js="spaces-pagination"]');
    const isSwiperModeSpaces = spacesGallery?.classList.contains('swiper-spaces');

    if (isSwiperModeSpaces) {
        const swiperWelcome = new Swiper(swiperSpacesEl, {
            modules: [Autoplay, Pagination],
            loop: true,
            rewind: false,
            centeredSlides: true,
            autoplay: {
                delay: 2000,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: spacesPagination,
                type: 'progressbar',
                modifierClass: 'spaces__pagination--',
                horizontalClass: 'spaces__pagination--horizontal',
                progressbarFillClass: 'spaces__progress',
            },
            breakpoints: {
                320: { slidesPerView: 1.25, spaceBetween: 10 },
                390: { slidesPerView: 2.25, spaceBetween: 10 },
                640: { slidesPerView: 2.25, spaceBetween: 10 },
                768: { slidesPerView: 2.75, spaceBetween: 10 },
                1024: { slidesPerView: 4.25, spaceBetween: 10 },
                1280: { slidesPerView: 4.25, spaceBetween: 10 }
            }
        });
    }

    const swiperExteriorEl = document.querySelector(".swiper-gallery-exterior");
    const exteriorGallery = document.querySelector('[data-js="gallery-exterior-gallery"]');
    const isSwiperModeEx = exteriorGallery?.classList.contains('swiper-gallery-exterior');

    if (isSwiperModeEx) {
        const swiperWelcome = new Swiper(swiperExteriorEl, {
            modules: [Autoplay, Pagination],
            loop: true,
            rewind: false,
            centeredSlides: true,
            autoplay: {
                delay: 2000,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: '.gallery-exterior__pagination',
                clickable: true,
                bulletClass: 'gallery-exterior__bullet',
                bulletActiveClass: 'gallery-exterior__bullet--active',
            },
            breakpoints: {
                320: { slidesPerView: 1.25, spaceBetween: 5 },
                390: { slidesPerView: 1.25, spaceBetween: 10 },
                640: { slidesPerView: 1.25, spaceBetween: 10 },
                768: { slidesPerView: 1.75, spaceBetween: 20 },
                1024: { slidesPerView: 1.25, spaceBetween: 20 },
                1280: { slidesPerView: 1.5, spaceBetween: 20 }
            }
        });
    }

    new FloorsGraphic({
        defaultColor: '#333',
        highlightColor: '#DA565D',
        graphicSelector: '#grafica_deptos',
        tabsSelector: '.models__tablist'
    });

    initAnimations();

});

